import Profile from '@/views/app/settings/Profile'
import Info from '@/views/app/settings/Info'
import Ngos from '@/views/app/settings/Ngos'
import Params from '@/views/app/settings/Params'
import Protectors from '@/views/app/settings/Protectors'
import Create from '@/views/app/settings/users/Create'
import List from '@/views/app/settings/users/List'
import Account from '@/views/app/settings/Account'
import ChangeEmail from '@/views/app/settings/Account/ChangeEmail'
import ResetPassword from '@/views/app/settings/Account/ResetPassword'
import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'

function SettingsRoutes() {
  const { path } = useRouteMatch()

  return (
    <div>
      <Route exact path={`${path}/users`}>
        <List title="Petis - Parceiros / Configurações / Usuários" />
      </Route>
      <Route exact path={`${path}/users/create`}>
        <Create title="Petis - Parceiros / Configurações / Usuários / Novo Usuário" />
      </Route>
      <Route exact path={`${path}/profile`}>
        <Profile title="Petis - Parceiros / Configurações / Perfil" />
      </Route>
      <Route exact path={`${path}/params`}>
        <Params title="Petis - Parceiros / Configurações / Parâmetros" />
      </Route>
      <Route exact path={`${path}/ngos`}>
        <Ngos title="Petis - Parceiros / Configurações / ONG's" />
      </Route>
      <Route exact path={`${path}/protectors`}>
        <Protectors title="Petis - Parceiros / Configurações / Protetores" />
      </Route>
      <Route exact path={`${path}/info`}>
        <Info title="Petis - Parceiros / Configurações / Institucional" />
      </Route>
      <Route exact path={`${path}/account`}>
        <Account title="Petis - Parceiros / Configurações / Conta" />
      </Route>
      <Route exact path={`${path}/account/change-email`}>
        <ChangeEmail title="Petis - Parceiros / Configurações / Conta / Alterar e-mail" />
      </Route>
      <Route exact path={`${path}/account/reset-password`}>
        <ResetPassword title="Petis - Parceiros / Configurações / Conta / Redefinir senha" />
      </Route>
    </div>
  )
}

export default SettingsRoutes
